import { render, staticRenderFns } from "./CompanyRLSDropdown.vue?vue&type=template&id=b897ac48&scoped=true"
import script from "./CompanyRLSDropdown.vue?vue&type=script&lang=js"
export * from "./CompanyRLSDropdown.vue?vue&type=script&lang=js"
import style0 from "./CompanyRLSDropdown.vue?vue&type=style&index=0&id=b897ac48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b897ac48",
  null
  
)

export default component.exports